/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../layout/content/Content";
import {
    Spinner, Modal,
    ModalBody, ModalFooter } from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
    BlockDes,
    BlockHead,
    PaginationComponent,
} from "../../../../components/Component";
import Head from "../../../../layout/head/Head";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionS from "../../../components/DynmicOption/OptionS";
import OptionC from "../../../components/DynmicOption/OptionC";
import OptionM from "../../../components/DynmicOption/OptionM";
import ES5part2ReportEmployment from "./ES5part2ReportEmployment";
import loadspinner from "../../../../assets/images/spinner.gif"
import Swal from "sweetalert2"

const ES5part2DataReport = ({ ...props }) => {
    const [itemPerPage, setItemPerPage] = useState(1000);
    const [currentPage, setCurrentPage] = useState(1);
    const [Statee, setStatee] = useState([]);
    const [lorder, setLorder] = useState(true);
    const [modal, setmodal] = useState(false);
    const [load, setload] = useState(false);
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [id, setid] = useState(0);
    const today = new Date();
    const tableRef = useRef(null);
    const [loadmain, setloadmain] = useState(true);
    const tableRef1 = useRef(null);
    const [generate1, setgenerate1] = useState(true);
    const [nextloading, setnextloading] = useState(false);
    const [loading, setloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() + 1 : sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth() + 1] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 1,
        state: -1
    });
    const [states, setstates] = useState("")

    const [DataCount, setDataCount] = useState(0)
    //console.log(DataCount)
    const paginate = (pageNumber) => {
        setnextloading(true)
        setStatee([])
        var mainid = document.getElementById("datashow");
        mainid.scrollIntoView()
        //console.log("MainId", mainid)
        setCurrentPage(pageNumber)

        if (formData.state !== "0") { getdata3(pageNumber) } else { getdataAll(pageNumber) }


    };
    const onInputChange = (e) => {
        var index = e.nativeEvent.target.selectedIndex;
        setstates(e.nativeEvent.target[index].text)
        setFormData({ ...formData, [e.target.name]: e.target.value });
   
    };
    const onInputChange2 = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const onInputChange3 = (tomonth, toyear) => {
        setFormData({ ...formData, tomonth: tomonth, toyear: toyear });

    };
    const getdata3 = async (pageno) => {
        const sendData = {

            EmploymentRefId: Number(6),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth),
            Take: Number(itemPerPage),
            Skip: Number((pageno - 1) * itemPerPage)
        }
        
        // Validate UserId before sending request
        if (sendData.UserId < 1) {
            console.error('Invalid UserId:', sendData.UserId);
            setStatee([]);
            setload(true);
            setmodal(false);
            setnextloading(false);
            alert("Please select a state.");
            return;
        }

        console.log('Sending request with data:', sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES5PA2MIS', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    // console.log(data)
                    setStatee(data)
                    if (data.length === 0) {
                        setmodal(false)

                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)

                })


    };

    const getdatacount = async () => {
        const sendData = {

            EmploymentRefId: Number(6),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/COUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                     // console.log("Count", data)
                    setDataCount(data)

                })


    };

    const getdatacountAll = async () => {
        const sendData = {

            EmploymentRefId: Number(6),
            UserId: Number(0),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ALLCOUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log("Count", data)
                    setDataCount(data)

                })


    };

    const getdataAll = async (page) => {

        try {
            const sendData = {
                EmploymentRefId: Number(6),
                UserId: Number(0),
                StateId: formData.state === "0" ? null : Number(formData.state),
                MonthId: Number(formData.month),
                YearId: Number(formData.year),
                ToYearId: Number(formData.toyear),
                ToMonthId: Number(formData.tomonth),
                Take: Number(itemPerPage),
                Skip: Number((page - 1) * itemPerPage)
            }
            //console.log(sendData)
            await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES5PA2MISAll', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(sendData)

            })
                .then(response => response.json())
                .then(
                    data => {
                        // console.log(data)
                        setStatee(data)
                        if (data.length === 0) {
                            setmodal(false)

                        }
                        setload(true)
                        setmodal(false)
                        setnextloading(false)

                    })

        } catch (error) {
            setStatee([]);
            setload(false);
            setnextloading(false);
            setmodal(false);
            Swal.fire({
                icon: "error",
                title: "Something went wrong",
                text: "Please try after sometime...",
                focusConfirm: false,
            }).then(() => {
                window.location.reload()
            })

        }
    };

    const generateAll = async () => {
        sessionStorage.setItem("NumberES5pa2", 0)
        setloadmain(false)
        setmodal(true)
        setload(false)
        getdatacountAll()
        getdataAll(1)
        setgenerate1(false)



    }

    const generate = async () => {
        // Validate that a valid state has been selected
        if (formData.state === -1) {
            alert("Please select a state.");
            return;
        }

        sessionStorage.setItem("NumberES5pa2", 0)
        setloadmain(false)
        getdatacount()
        getdata3(1)
        setgenerate1(false)
        setmodal(true)
    }
    useEffect(() => {


        if (modal) {
            // console.log("Start")
            const iimain = setTimeout(() => {
                setmodal(false)

            }, 500000);

            setid(iimain);

        }
        else {
            //console.log("Closed", id)
            window.clearTimeout(id);
            setid(0);
        }

    }, [modal])
  
    const TableRow = React.memo(({ details, itemPerPage, currentPage, month1, index }) => {
        return (
            <tr key={index}>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {(itemPerPage * (currentPage - 1)) + index + 1}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{details.yearId}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{month1[details.monthId]}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{details.state}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{details.center}</b>
                </td>
                {details.eSdata.map((data, dataIndex) => (
                    (data.parametersId !== 80 && data.parametersId !== 84) ? (
                        <React.Fragment key={dataIndex}>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }}>
                                {data.centalGovt3 === null ? 0 : data.centalGovt3}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }}>
                                {data.unionTerritory4 === null ? 0 : data.unionTerritory4}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }}>
                                {data.stateGovt5 === null ? 0 : data.stateGovt5}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }}>
                                {data.centalGovt6 === null ? 0 : data.centalGovt6}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }}>
                                <label>{data.stateGovt7 === null ? 0 : data.stateGovt7}</label>
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.localBodies8 === null ? 0 : data.localBodies8}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.privateEstt9 === null ? 0 : data.privateEstt9}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.total10 === null ? 0 : data.total10}
                            </td>
                        </React.Fragment>
                    ) : null
                ))}
            </tr>
        );
    });


    return (
        <React.Fragment>
            <Head title="ES5Part2Report" />
            <Content>
                {loading ? (
                    <Spinner color="success" />
                ) : (
                    <Block>
                            <BlockHead size="lg">
                                <BlockDes className="text-soft">
                                    <Row>
                                        <Col xl="2" md="2">
                                            <h5 style={{ color: '#798bff' }}>DGE Dashboard</h5>
                                        </Col>
                                        <Col xl="3" md="3">
                                            <label style={{ color: 'black', fontSize: 15 }}>
                                                State :{' '}
                                                <label style={{ fontWeight: 'bold' }}>
                                                    <OptionS
                                                        catid="43"
                                                        onInputChange={onInputChange}
                                                        namemain="state"
                                                        mainid="state"
                                                    />
                                                </label>
                                            </label>
                                        </Col>
                                        <Col xl="3" md="3">
                                            <label style={{ color: 'black', fontSize: 15 }}>
                                                From:{' '}
                                                <label style={{ fontWeight: 'bold' }}>
                                                    <OptionC
                                                        onInputChange={onInputChange2}
                                                        year={formData.year}
                                                        month={formData.month}
                                                    />
                                                </label>
                                            </label>
                                        </Col>
                                        <Col xl="3" md="3">
                                            <label style={{ color: 'black', fontSize: 15 }}>
                                                To:{' '}
                                                <label style={{ fontWeight: 'bold' }}>
                                                    <OptionM
                                                        onInputChange={onInputChange3}
                                                        year={formData.year}
                                                        month={formData.month}
                                                    />
                                                </label>
                                            </label>
                                        </Col>
                                        <Col xl="3" md="3">
                                            {formData.state !== String(0) ? (
                                                <Button
                                                    color="success"
                                                    style={{ marginTop: 10 }}
                                                    onClick={() => generate()}
                                                >
                                                    Generate
                                                </Button>
                                            ) : (
                                                <Button
                                                    color="success"
                                                    style={{ marginTop: 10 }}
                                                    onClick={() => generateAll()}
                                                >
                                                    Generate
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                </BlockDes>
                            </BlockHead>
                        <Modal isOpen={false} fullscreen="xl" size="xl" >
                            <ModalBody>

                                <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img src={loadspinner} alt="load" />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={() => window.location.reload()}>
                                    Stop Report
                                </Button>{' '}

                            </ModalFooter>
                        </Modal>
                                <hr />
                            {generate1 ? (
                                <h3>Please Select State and Month to Generate Report!!</h3>) :
                            <>
                                 {modal ? (
                                        <div>
                                            <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                Please wait while the report is loading......
                                            </h3><br />
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Spinner size="xl" />
                                            </div>
                                        </div>
                                    ) : null}
                                <div style={{ visibility: modal ? "hidden" : "visible" }}>
                                
                                <Row>
                                    <Col md="2" lg="3">
                                        <h4 style={{ marginBottom: 40 }}>Employment Report (ES5 Part2)</h4>
                                    </Col>
                                    <Col md="2" lg="3"> </Col>
                                    {loadmain ?(
                                        <Col md="2" lg="3">
                                           
                                            <Button disabled style={{ float: "right", marginBottom: 10 }} color="danger" ><Icon className="icon ni ni-download"></Icon>Export Excel Abbreviation</Button>
                                           
                                        </Col>
                                    ) :( 
                                        <Col md="2" lg="3">
                                            <DownloadTableExcel
                                                filename="ES5 Part2 Abbreviation"
                                                sheet="users"
                                                currentTableRef={tableRef1.current}
                                            >
                                                <Button style={{ float: "right", marginBottom: 10 }} color="warning" ><Icon className="icon ni ni-download"></Icon>Export Excel Abbreviation</Button>
                                            </DownloadTableExcel>
                                        </Col>
                                        )}

                                    {loadmain ? (
                                        <Col md="2" lg="3">
                                            <Button disabled style={{ float: "right" }} color="danger" ><Icon className="icon ni ni-download"></Icon>Export Excel</Button>
                                            
                                        </Col>
                                    ):( 
                                        <Col md="2" lg="3">
                                            <DownloadTableExcel
                                                filename="ES5 part2 Report"
                                                sheet="users"
                                                currentTableRef={tableRef.current}
                                            >
                                                <Button style={{ float: "right" }} color="info" ><Icon className="icon ni ni-download"></Icon>Export Excel</Button>
                                            </DownloadTableExcel>
                                        </Col>
                                        )}
                                </Row>


                                <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                    <table className="table table-orders" ref={tableRef1} style={{ borderCollapse: "separate", borderSpacing: 0, border: '1px solid black' }}>
                                        <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0 }}>


                                            <tr> <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                Item

                                            </th>
                                                <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                    Abbreviation

                                                </th>
                                                <br />
                                                <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                    Item

                                                </th>
                                                <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                    Abbreviation

                                                </th>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >No of vacancies outstanding for pwd at the end of the previous month</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PWD_VA_OS_PM</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Cental Govt.</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >CG</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >No of vacancies for pwd</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PWD_VA_R</td>

                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "200px" }} >Union Territory</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", alignItems: "center" }} >UT</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >(a) Notified during the month</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >PWD_VA_NO_M</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >State Govt.</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SG</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >(b) filled during the month</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PWD_VA_FI_M</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Quasi Govt Estt/Public Sector Undertakings---Cental Govt</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PWD_Q_CG_U</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >(c) Cancelled during the month due to</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PWD_VA_CA_M</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Quasi Govt Estt/Public Sector Undertakings----State Govt</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PWD_Q_SG_U</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >(i) Non- availability of suitable candidate</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PWD_VA_CA_M_NASC</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Local Bodies</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >LB</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >(ii) Other reasons</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >PWD_VA_CA_M_OR</td>

                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Private Estt.</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PE</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >No of vacancies for pwd outstanding at the end of the month</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PWD_VA_OS_M</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Total</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Tot</td>

                                            </tr>


                                        </thead>

                                    </table>

                                </div>

                                <div className="card-inner-group" style={{ border: '4px solid black', padding: 2 }}>

                                    <div style={{ height: window.innerHeight - 100, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                        
                                        <table className="table " ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                            <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                             <span id="datashow" style={{ visibility: "hidden", height: 0, width: 0 }}></span>
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                    <tr>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            Form: ES5 Part2 Report

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            State: {states}

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            From Date: {month1[formData.month]} {formData.year}

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            To Date: {month1[formData.tomonth]} {formData.toyear}

                                                        </th>
                                                    </tr>
                                                </thead>
                                            </div>
                                            <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                <tr>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        S. No.
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        Year
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        Month
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        State
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        Employment Exchange
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_PM CG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_PM UT
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_PM SG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_PM PWD_Q_CG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_PM PWD_Q_SG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_PM LB
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_PM PE
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_PM Tot
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA CG_R
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA UT_R
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA SG_R
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA PWD_Q_CG_U_R
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA PWD_Q_SG_U_R
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA LB_R
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA PE_R
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA Tot
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_NO_M CG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_NO_M UT
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_NO_M SG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_NO_M PWD_Q_CG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_NO_M PWD_Q_SG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_NO_M LB
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_NO_M PE
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_NO_M Tot
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_FI_M CG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_FI_M UT
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_FI_M SG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_FI_M PWD_Q_CG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_FI_M PWD_Q_SG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_FI_M LB
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_FI_M PE
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_FI_M Tot
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M CG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M UT
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M SG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M PWD_Q_CG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M PWD_Q_SG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M LB
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M PE
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M Tot
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_NASC CG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_NASC UT
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_NASC SG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_NASC PWD_Q_CG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_NASC PWD_Q_SG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_NASC LB
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_NASC PE
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_NASC Tot
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_OR CG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_OR UT
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_OR SG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_OR PWD_Q_CG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_OR PWD_Q_SG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_OR LB
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_OR PE
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_CA_M_OR Tot
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_M CG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_M UT
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_M SG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_M PWD_Q_CG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_M PWD_Q_SG_U
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_M LB
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_M PE
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        PWD_VA_OS_M Tot
                                                    </th>



                                                </tr>


                                            </thead>

                                            <tbody>
                                                    {nextloading ? (
                                                        <tr>
                                                            <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                                                <div>
                                                                    <h3>Please wait while the report is loading...</h3>
                                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Spinner size="xl" />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : load ? (
                                                        Statee.length !== 0 && nextloading === false ? (
                                                            Statee.map((details, index) => (
                                                                <TableRow
                                                                    key={index}
                                                                    details={details}
                                                                    itemPerPage={itemPerPage}
                                                                    currentPage={currentPage}
                                                                    month1={month1}
                                                                    index={index}
                                                                />
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" style={{ textAlign: 'center' }}>
                                                                    <h3>No Data Found</h3>
                                                                </td>
                                                            </tr>
                                                        )
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" style={{ textAlign: 'center' }}>
                                                                <Spinner color="success" />
                                                            </td>
                                                        </tr>
                                                    )}


                                            </tbody>
                                        </table>

                                    </div>



                                </div>

                                </div>

                                    {Statee.length > 0 && (
                                        <PaginationComponent
                                            noDown
                                            itemPerPage={itemPerPage}
                                            totalItems={DataCount}
                                            paginate={paginate}
                                            currentPage={currentPage}
                                            EmploymentRefId={5}
                                            UserId={formData.state}
                                            MonthId={formData.month}
                                            YearId={formData.year}
                                            ToYearId={formData.toyear}
                                            ToMonthId={formData.tomonth}
                                            setStatee={setStatee}
                                            setmodal={setmodal}
                                            setload={setload}
                                        />
                                    )}
                                </>}

                            <Modal isOpen={false} fullscreen="xl" size="xl" >
                                <ModalBody>

                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <img src={loadspinner} alt="load" />
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={() => window.location.reload()}>
                                        Stop Report
                                    </Button>{' '}

                                </ModalFooter>
                            </Modal>




                    </Block>
                )}

            </Content>

        </React.Fragment>
    );
};

export default ES5part2DataReport;
